import { useState } from "react";

const useTextExpander = () => {
  const [isTextExpanded, setIsExpanded] = useState(false);

  const handleExpansion = (value) => {
    if (value) {
      setIsExpanded(value);
      return;
    }
    setIsExpanded(false);
  };
  return [isTextExpanded, handleExpansion];
};

export default useTextExpander;
